import React, { useState } from 'react';
import useTransmise from '../../Hooks/useTransmise';
import useFlatData from '../../../Base/Hooks/useFlatData';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import FlatList from '../../../Base/Components/FlatList';
// @ts-ignore
import styles from './TransmiseList.module.scss';
import DASTAListItem from '../DASTAListItem/DASTAListItem';
import { useLazyUserVzpRegisteredDoctorsQuery } from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import { useEffectAsync } from '../../../../helpers';
import useCertificates from '../../../Certificates/Hooks/useCertificates';
import apiClient from '../../../../Services/ApiClient';
import useNotification from '../../../../Hooks/useNotification.hook';
import { useAppContext } from '../../../../Services/AppContext';
import useTranslation from '../../../../Hooks/useTranslation';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import Text from '../../../../Components/Base/Text/Text';

const wrapperId = 'transmiseListWrapper';

interface Props {
	patientId: string;
}

const TransmiseList: React.FC<Props> = ({ patientId }) => {
	const [isLoadingVZP, setIsLoadingVZP] = useState(false);
	const { getFlatTransmiseList, getNextPage, data, isLoading, page, setPage } =
		useTransmise();
	const [userHasRegisteredDoctors, setUserHasRegisteredDoctors] =
		useState(false);
	const [getRegisteredDoctors] = useLazyUserVzpRegisteredDoctorsQuery();
	const { checkUserCertificateAvailability } = useCertificates();
	const { showNotificationAlert } = useNotification();
	const { t } = useTranslation();
	const { userData } = useAppContext();

	const { flatData, hasMoreData, loadData } = useFlatData(
		getFlatTransmiseList,
		{
			data: data?.transmiseList?.data,
			totalPages: data?.transmiseList?.meta?.totalPages,
			page: data?.transmiseList?.meta?.page,
		},
		page,
		setPage,
		{
			userId: patientId,
			dateFrom: '2023-01-01',
			dateTo: '2025-02-27',
		},
	);

	const handleVerifyDoctors = async () => {
		setIsLoadingVZP(true);

		const qualifiedCertificate = await checkUserCertificateAvailability(
			userData.id,
			'qualified',
		);

		if (qualifiedCertificate) {
			await apiClient.put(`/patients/${patientId}/vzp/registrujici-lekari`, []);
		} else {
			showNotificationAlert({
				content: t('component.certificates.noCertificatesVerify'),
			});
		}

		await handleLoadPSZ();
	};

	const handleLoadPSZ = async () => {
		setIsLoadingVZP(true);
		const data = await getRegisteredDoctors({ id: patientId });
		if (data?.data?.user?.vzpRegisteredDoctorsResult?.result) {
			setUserHasRegisteredDoctors(true);
		}
		setIsLoadingVZP(false);
	};

	useEffectAsync(async () => {
		await handleLoadPSZ();
	}, []);

	if (isLoading || isLoadingVZP) {
		return <Loading />;
	}

	console.log('flatData', flatData);

	if (userHasRegisteredDoctors) {
		if (flatData.length > 0) {
			return (
				<div className={styles.wrapper}>
					<ScrollContainer wrapperId={wrapperId} className={styles.list}>
						<FlatList
							onRefresh={loadData}
							onLoadMore={getNextPage}
							data={flatData}
							isLoading={isLoading}
							hasMoreData={hasMoreData}
							scrollableTargetId={wrapperId}
							renderItem={item => <DASTAListItem item={item} />}
						/>
					</ScrollContainer>
				</div>
			);
		}

		return (
			<div className={styles.wrapper}>
				<div className={styles.infoWrapper}>
					<Text tx='component.transmiseList.nodata' />
				</div>
			</div>
		);
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.infoWrapper}>
				<div className='mb-3'>
					<Text tx='component.transmiseList.text' />
				</div>
				<Button
					onClick={handleVerifyDoctors}
					title='patientTreatment.profile.verifyDoctors.title'
					theme={Theme.GREEN}
					fitContent
				/>
			</div>
		</div>
	);
};

export default TransmiseList;
